import Colors from 'constants/Colors';

export default {
  container: {
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
  },
  hotelSelectorContainer: {
    width: '100%',
    maxWidth: 400,
    minWidth: 220,
    marginTop: 12,
    marginBottom: 12,
  },
  languageSelectorContainer: {
    width: '100%',
    maxWidth: 400,
    minWidth: 220,
    marginBottom: 12,
  },
  buttonStyle: {
    minWidth: 220,
    maxWidth: 320,
    fontSize: 13,
  },
  title: {
    color: Colors.darkText,
    fontSize: 12,
    fontWeight: 'bold',
  },
};
